import React from 'react';
import { PageComponentProps } from 'shared/interface/globalInterface';
import { CommissionListingPage } from '../pages';

type Props = PageComponentProps;

const Index: React.FC<Props> = () => {
  return (
    <>
      <CommissionListingPage />
    </>
  );
};

export default Index;
